import { Component, OnInit } from '@angular/core';
import { StreamService } from '../../Service/Stream/stream.service';
import {Router} from '@angular/router';
import { StreamModel } from '../../Model/Stream/stream.model';
import {environment} from '../../../environments/environment';

@Component({
  selector: 'app-stream',
  templateUrl: './stream.component.html',
  styleUrls: ['./stream.component.css']
})
export class StreamComponent implements OnInit {
  streamlist:StreamModel;
  imageFolder:string;
  Customlist=[];
  id:number;
 
  constructor(private _StreamService: StreamService, private router: Router) 
  {
    this.imageFolder=environment.imageFolder;
   }
  
  ngOnInit() {
   this.GetStream();
   this.GetSelectedForm(this.id);

  }

  GetStream(){
    this._StreamService.GetStream().subscribe(
      res=>{
        this.streamlist= res.responseData;
      }
    )
  }

  GetSelectedForm(id:number){
    var id =5
   this._StreamService.SelectedCustomForm(id).subscribe(
     res=>{
       this.Customlist=res.responseData;
     }
   )   
 }

}
